import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import { supabase } from '../supabase';
import './sec-event-content-mangement.css'
import Contentmangementnav from '../component/common/contentnav';
import pic42 from '../assets/pic42.png'
import Input from '../component/common/input';
import pic34 from '../assets/pic34.png'
import pic30 from '../assets/pic30.png'
import pic31 from '../assets/pic31.png'
import pic32 from '../assets/pic32.png'
import pic35 from '../assets/pic35.png'
import Circlecta from '../component/common/circlectsa';


const FAQscontentmangement = () => {

const [faqs, setFaqs] = useState([]);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('');
    
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);




const [formData, setFormData] = useState({
  question_name: '',
  answer: '',
  question_name_ar: '',
  answer_ar: '',
  show: true
});

    
useEffect(() => {
        const getFAQs = async () => {
            const { data, error } = await supabase
            .from('FAQs')
            .select('*');

            if (error) {
            console.log("FAQ ERROR:", error);
            return;
            }

            setFaqs(data || []);
        };

        getFAQs();
}, []);


    
    
const filteredFAQs = faqs.filter((item) => {
  const matchesSearch =
    (item.question_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item.answer?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item.question_name_ar?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item.answer_ar?.toLowerCase() || '').includes(search.toLowerCase());

  let matchesFilter = true;

  if (filter === 'shown') {
    matchesFilter = item.show === true;
  }

  if (filter === 'hidden') {
    matchesFilter = item.show === false || item.show === null;
  }

  return matchesSearch && matchesFilter;
});

const createFAQ = async () => {
  const { error } = await supabase
    .from('FAQs')
    .insert([formData]);

  if (error) {
    console.log(error);
    return;
  }

  const { data } = await supabase.from('FAQs').select('*');
  setFaqs(data);
  handleClose();
};


const handleEditClick = (item) => {
  setFormData({
    question_name: item.question_name || '',
    answer: item.answer || '',
    question_name_ar: item.question_name_ar || '',
    answer_ar: item.answer_ar || '',
    show: item.show ?? true
  });

  setEditingId(item.id);
  setIsEditing(true);
  setShowForm(true);
};

const updateFAQ = async () => {
  const { error } = await supabase
    .from('FAQs')
    .update(formData)
    .eq('id', editingId);

  if (!error) {
    const { data } = await supabase.from('FAQs').select('*');
    setFaqs(data);
    handleClose();
  }
};


const confirmDelete = async () => {
  await supabase.from('FAQs').delete().eq('id', selectedDeleteId);

  setFaqs(prev => prev.filter(item => item.id !== selectedDeleteId));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};



const handleClose = () => {
  setShowForm(false);
  setIsEditing(false);
  setEditingId(null);

  setFormData({
    question_name: '',
    answer: '',
    question_name_ar: '',
    answer_ar: '',
    show: true
  });
};




    return ( 
     
<section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Landing Page Content"  
                            para="Manage featured events, FAQs, and testimonials"
                            />
                     
                        
                        </article>


                        {showForm && (
                                                <div className="overlay-create">
                                                <div className="container-create">

                                                    <div className="header-create">
                                                    <h1 className="title-create">
                                                        {isEditing ? 'Edit FAQ' : 'Add FAQ'}
                                                    </h1>

                                                    <button
                                                        className="close-btn-create"
                                                        onClick={handleClose}
                                                        type="button"
                                                    >
                                                        <img src={pic34} alt='close' />
                                                    </button>
                                                    </div>

                                                    <form
                                                    className="form-create"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        isEditing ? updateFAQ() : createFAQ();
                                                    }}>

                                                    <Input
                                                        title="Question"
                                                        placeholder="Enter question"
                                                        value={formData.question_name}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, question_name: e.target.value })
                                                        } />

                                                    <Input
                                                        title="Answer"
                                                        placeholder="Enter answer"
                                                        value={formData.answer}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, answer: e.target.value })
                                                        } />

                                                    <Input
                                                        title="Question (Arabic)"
                                                        placeholder="Enter Arabic question"
                                                        value={formData.question_name_ar}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, question_name_ar: e.target.value })
                                                        }/>

                                                    <Input
                                                        title="Answer (Arabic)"
                                                        placeholder="Enter Arabic answer"
                                                        value={formData.answer_ar}
                                                        onChange={(e) =>
                                                        setFormData({ ...formData, answer_ar: e.target.value })
                                                        }/>

                                                    <fieldset className="fieldset">
                                                        <label className='title-input'>Show FAQ</label>

                                                        <div className="select-wrapper2">
                                                        <img src={pic28} className="arrow-icon2" alt="arrow" />

                                                        <select
                                                            className="input-search2 select-style2"
                                                            value={formData.show ? "true" : "false"}
                                                            onChange={(e) =>setFormData({ ...formData, show: e.target.value === 'true' })}>
                                                            <option value="true">Show</option>
                                                            <option value="false">Hide</option>
                                                        </select>
                                                        </div>
                                                    </fieldset>

                                                    <nav className='container-ctas-craete'>
                                                        <button
                                                        type="button"
                                                        className="cta-cancel-create"
                                                        onClick={handleClose}
                                                        >
                                                        <h2 className="cta-cancel-text-create">Cancel</h2>
                                                        </button>

                                                        <button type="submit" className='cta-create'>
                                                        <h2 className='cta-create-text'>
                                                            {isEditing ? 'Edit FAQ' : 'Add FAQ'}
                                                        </h2>
                                                        </button>
                                                    </nav>

                                                    </form>
                                                </div>
                                                </div>
                                                )}



                                                {showDeleteModal && (
                                                <section className="delete-modal-overlay">
                                                    <article className="delete-modal">

                                                    <header className="delete-modal-header">
                                                        <div className="delete-icon-wrapper">
                                                        <img src={pic35} alt='icon' />
                                                        </div>

                                                        <div className="delete-text-container">
                                                        <h2 className="delete-title">Delete FAQ</h2>
                                                        <p className="delete-description">
                                                            Are you sure you want to delete this FAQ?
                                                        </p>
                                                        </div>
                                                    </header>

                                                    <nav className="delete-modal-actions">
                                                        <button
                                                        className="delete-btn-cancel"
                                                        onClick={() => {
                                                            setShowDeleteModal(false);
                                                            setSelectedDeleteId(null);
                                                        }}
                                                        >
                                                        Cancel
                                                        </button>

                                                        <button
                                                        className="delete-btn-confirm"
                                                        onClick={confirmDelete}
                                                        >
                                                        Delete
                                                        </button>
                                                    </nav>

                                                    </article>
                                                </section>
                                                )}



<section className='container-table-and-section'>


                        <Contentmangementnav />



                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper-about">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />

                                 <Circlecta  onClick={() => setShowForm(true)}/>

                            </fieldset>



                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                        <option value="shown">Shown</option>
                                        <option value="hidden">Hidden</option>
                                </select>
                                </div>


                            </fieldset>



                             <div className="table-container" >
                                 <table className='table-table-concert-mangem'>
                                                                   
                                {filteredFAQs.map((item) => { return <tbody key={item.id}>
                               
                                                                 <tr className="row-table2-contenttt">

                                                 <div className="container-table-info-row-sec">

                                                    <div className='main-info'>

                                                    <h2 className="header-support">
                                                        {item.question_name}
                                                    </h2>

                                                    <p className="sentfrom-support">
                                                        {item.answer}
                                                    </p>
                                                    </div>

                            <nav className='right-box-about'>
                                                <label className="custom-checkboxl">
                                                   <input
                                                    type="checkbox"
                                                    checked={item.show || false}
                                                    onChange={async () => {
                                                        const newValue = !item.show;

                                                        await supabase
                                                        .from('FAQs')
                                                        .update({ show: newValue })
                                                        .eq('id', item.id);
                                                        setFaqs(prev =>
                                                        prev.map(el =>
                                                            el.id === item.id ? { ...el, show: newValue } : el
                                                        )
                                                        );
                                                    }}
                                                    />
                                                    <span className="checkmarkcontent"></span>
                                                    <h3 className="SHOW">Show on homepage</h3>
                                                </label>


                                                <nav className='cta-table'>

                                                    <button className='cta2-table'>
                                                        <img src={pic30} alt='hide' />
                                                    </button>

                                                    <button
                                                        className='cta2-table'
                                                        onClick={() => handleEditClick(item)}
                                                    >
                                                        <img src={pic31} alt='edit' />
                                                    </button>

                                                    <button
                                                        className='cta2-table'
                                                        onClick={() => {
                                                        setSelectedDeleteId(item.id);
                                                        setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        <img src={pic32} alt='delete' />
                                                    </button>

                                                </nav>

                                        </nav>


                                                </div>

                                                


                                                <div className='line-supporttt'></div>
                                                     <div className='main-info3'>
                                                    <h3 className="header-support-ar">
                                                        {item.question_name_ar}
                                                    </h3>

                                                    <p className="sentfrom-support-ar">
                                                        {item.answer_ar}
                                                    </p>
                                                    </div>
                                                </tr>
                               
                               
                               
                                             </tbody>
                                              })}
                                         </table>
                                </div>

                        </section>


                    </section>

            </section>
            </section>
        </section>


     );
}
 
export default FAQscontentmangement;